import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { StepType, PartnerInviteModel, ErrorStateService, RegistrationStepService, LoggingService, RegistrationStepQuery } from '@fgb/core';
import { FGBValidators } from '@fgb/portal-component-library/src/lib/shared/validators';

@Component({
  selector: 'fgbcl-registration-partner-invite',
  templateUrl: './registration-partner-invite.component.html',
  styleUrls: ['./registration-partner-invite.component.scss']
})
export class RegistrationPartnerInviteComponent implements OnInit {
  readonly stepType: StepType = StepType.ProcessPartnerRequest;
  partnerForm: UntypedFormGroup;

  constructor(
    private registrationStepQuery: RegistrationStepQuery,
    private logService: LoggingService,
    private registrationStepService: RegistrationStepService,
    public errorService: ErrorStateService,
    private fb: UntypedFormBuilder
  ) {}

  ngOnInit() {
    const stepData = this.registrationStepQuery.getStep(this.stepType);
    // Initialize form
    this.partnerForm = this._generatePartnerForm(stepData?.Data || {} as PartnerInviteModel);
  }

  /**
   * Generate partner form
   */
  private _generatePartnerForm(codes: PartnerInviteModel){
    return this.fb.group({
      PartnerCode: [ codes.PartnerCode || '', [ Validators.required, FGBValidators.Empty ]],
      PartnerSecretCode: [ codes.PartnerSecretCode || '', [ Validators.required, FGBValidators.Empty ] ]
    });
  }

  submitStep() {
    this.errorService.clearErrors();
    this.partnerForm.markAllAsTouched();

    if( !this.partnerForm.valid ){
      this.logService.info('Form is invalid', this.partnerForm);
      return;
    }

    this.logService.info('Attempting step submission.');

    const { PartnerCode, PartnerSecretCode } = this.partnerForm.value;
    const stepData: PartnerInviteModel = { PartnerCode: PartnerCode.trim() , PartnerSecretCode : PartnerSecretCode.trim() };
    this.registrationStepService.submitRegistrationStepData(this.stepType, stepData).toPromise();
  }

}

